export var UploadBulkType = /*#__PURE__*/ function(UploadBulkType) {
    UploadBulkType["Valid"] = "valid";
    UploadBulkType["Invalid"] = "invalid";
    return UploadBulkType;
}({});
export var UploadBulkJobType = /*#__PURE__*/ function(UploadBulkJobType) {
    UploadBulkJobType["Valid"] = "valid";
    UploadBulkJobType["Invalid"] = "invalid";
    UploadBulkJobType["InProgress"] = "inProgress";
    return UploadBulkJobType;
}({});
export var BillType = /*#__PURE__*/ function(BillType) {
    BillType["BillNow"] = "BILL_NOW";
    BillType["BillOnDate"] = "BILL_ON_DATE";
    return BillType;
}({});
export var DiscountType = /*#__PURE__*/ function(DiscountType) {
    DiscountType["Percentage"] = "percentage";
    DiscountType["Currency"] = "currency";
    DiscountType["None"] = "none";
    return DiscountType;
}({});
